export default __webpack_public_path__ + "static/media/Barefeet-4.3a71eb16.webp";